import { useState } from 'react';
import { Camera, ChevronDown, ChevronRight } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { TicketDviPanel } from './TicketDviPanel';
import { useOptiDvi } from '@/hooks/useOptiDvi';

interface TicketDviSectionProps {
  ticketId: string;
  shopId: string;
  vehicle?: {
    year?: number;
    make?: string;
    model?: string;
  };
  onJobsAdded?: () => void;
}

export function TicketDviSection({ ticketId, shopId, vehicle, onJobsAdded }: TicketDviSectionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { isEnabled } = useOptiDvi();

  if (!isEnabled || !shopId) {
    return null;
  }

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="mb-3">
      <CollapsibleTrigger className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground hover:text-foreground transition-colors w-full">
        {isOpen ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <Camera className="h-3 w-3" />
        <span>DVI Inspection</span>
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-2">
        <TicketDviPanel 
          ticketId={ticketId} 
          shopId={shopId} 
          vehicle={vehicle}
          onJobsAdded={onJobsAdded}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}
